import * as Endpoints from './endpoints'

function prepareGetUrl(url: string, params?: { [key: string]: string }): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const query = new URLSearchParams(params as any)
  const queryString = query.toString()

  if (queryString) {
    return `${url}?${queryString}`
  }

  return url
}

async function parseAndThrowError(response: {
  status: number
  statusText: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  json: () => Promise<any>
}) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let errors: any = null

  try {
    errors = await response.json()
  } catch (e) {
    throw new Error(`${response.status} ${response.statusText}`)
  }

  if (errors) {
    throw errors
  }
}

export async function getApi<T extends keyof Endpoints.GET>(
  url: T,
  params?: Endpoints.GET[T]['params']
): Promise<Endpoints.GET[T]['result']> {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = await fetch(prepareGetUrl(url, params as any), options)

  if (!response.ok) {
    await parseAndThrowError(response)
  }

  return response.status === 204 ? null : response.json()
}

export async function postApi<T extends keyof Endpoints.POST>(
  url: T,
  params: Endpoints.POST[T]['params']
): Promise<Endpoints.POST[T]['result']> {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    await parseAndThrowError(response)
  }

  return response.status === 204 ? null : response.json()
}

export async function putApi<T extends keyof Endpoints.PUT>(
  url: T,
  params: Endpoints.PUT[T]['params']
): Promise<Endpoints.PUT[T]['result']> {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    await parseAndThrowError(response)
  }

  return response.status === 204 ? null : response.json()
}

export async function deleteApi<T extends keyof Endpoints.DELETE>(
  url: T,
  params?: Endpoints.DELETE[T]['params']
): Promise<Endpoints.DELETE[T]['result']> {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    await parseAndThrowError(response)
  }

  return response.status === 204 ? null : response.json()
}
